<ng-container *ngIf="carrierConnectAirline$ | async as airline">
  <h2 class="font-heading-5">{{ airline.name }}</h2>

  <fcom-notification
    class="ps-large-y"
    [theme]="NotificationTheme.INFO"
    [linkText]="
      'MMB.checkIn.funnel.steps.restrictedItems.carrierConnect.notification.linkText'
        | finLocalization: { operated: airline.name }
    "
    [linkOpenInNewWindow]="true"
    [linkUrl]="'https://link.oneworld.com/redirect/dangerous-goods/' + airline.code"
  >
    {{
      'MMB.checkIn.funnel.steps.restrictedItems.carrierConnect.notification.text'
        | finLocalization: { operated: airline.name }
    }}
  </fcom-notification>

  <div class="section-marker ps-large-b"></div>

  <h2 class="font-heading-5 ps-large-b">Finnair</h2>
</ng-container>

<div class="font-body-1 medium-type border white-bg rounded-large ps-medium mr-large-b">
  <fcom-notification class="ps-medium-b" *ngIf="'MMB.checkIn.steps.rules.titles.seasonal' | finHasLocalizationKey">
    <div class="ps-xsmall-b font-body-2 bold-type">
      {{ 'MMB.checkIn.steps.rules.titles.seasonal' | finLocalization }}
    </div>
    <div class="font-body-2">{{ 'MMB.checkIn.steps.rules.descriptions.seasonal' | finLocalization }}</div>
  </fcom-notification>
  <div class="border-bottom-dashed ps-medium-x ps-medium-b">
    <div class="flex flex--middle ps-medium-y">
      <h3 class="flex-1 font-heading-5">
        {{ 'MMB.checkIn.steps.rules.titles.allowedCarryOnBaggage' | finLocalization }}
      </h3>
      <div class="ps-medium-l flex--nogrow">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.CARRY_ON_BAG"></fcom-icon>
      </div>
      <div class="ps-medium-l flex--nogrow">
        <fcom-icon class="icon-large nordic-blue-300-text" [name]="SvgLibraryIcon.CHECKED_BAG_PROHIBITED"></fcom-icon>
      </div>
    </div>
    <ul class="no-list-style">
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.SPARE_LITHIUM_BATTERIES"></fcom-icon>
        <div class="ps-small-l">
          <div>{{ 'MMB.checkIn.steps.rules.titles.lithiumBatteriesLow' | finLocalization }}</div>
          <div class="font-body-2 regular-type">
            {{ 'MMB.checkIn.steps.rules.descriptions.lithiumBatteriesLow' | finLocalization }}
          </div>
        </div>
      </li>
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.POWER_BANK"></fcom-icon>
        <div class="ps-small-l">{{ 'MMB.checkIn.steps.rules.titles.powerBank' | finLocalization }}</div>
      </li>
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.E_CIGARETTE"></fcom-icon>
        <div class="ps-small-l">{{ 'MMB.checkIn.steps.rules.titles.eCigarette' | finLocalization }}</div>
      </li>
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.LIGHTERS_MATCHES"></fcom-icon>
        <div class="ps-small-l">{{ 'MMB.checkIn.steps.rules.titles.lighter' | finLocalization }}</div>
      </li>
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.LAPTOP"></fcom-icon>
        <div class="ps-small-l">
          <div>{{ 'MMB.checkIn.steps.rules.titles.personalElectricDevice' | finLocalization }}</div>
          <div class="font-body-2 regular-type">
            {{ 'MMB.checkIn.steps.rules.descriptions.personalElectricDevice' | finLocalization }}
          </div>
        </div>
      </li>
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.CAMERA"></fcom-icon>
        <div class="ps-small-l">{{ 'MMB.checkIn.steps.rules.titles.camera' | finLocalization }}</div>
      </li>
    </ul>
  </div>
  <div class="border-bottom-dashed ps-medium-x ps-medium-y">
    <div class="flex flex--midle ps-medium-y">
      <h3 class="flex-1 font-heading-5">
        {{ 'MMB.checkIn.steps.rules.titles.allowedCheckedBaggage' | finLocalization }}
      </h3>
      <div class="ps-medium-l flex--nogrow">
        <fcom-icon class="icon-large nordic-blue-300-text" [name]="SvgLibraryIcon.CARRY_ON_PROHIBITED"></fcom-icon>
      </div>
      <div class="ps-medium-l flex--nogrow">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.CHECKED_BAGGAGE"></fcom-icon>
      </div>
    </div>
    <ul class="no-list-style">
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.FIRE_ARMS"></fcom-icon>
        <div class="ps-small-l">
          <div>{{ 'MMB.checkIn.steps.rules.titles.weapons' | finLocalization }}</div>
          <div class="font-body-2 regular-type">
            {{ 'MMB.checkIn.steps.rules.descriptions.weapons' | finLocalization }}
          </div>
        </div>
      </li>
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.TAZER"></fcom-icon>
        <div class="ps-small-l">{{ 'MMB.checkIn.steps.rules.titles.stunGun' | finLocalization }}</div>
      </li>
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.TOOLS_AND_BLUNT_INSTRUMENTS"></fcom-icon>
        <div class="ps-small-l">{{ 'MMB.checkIn.steps.rules.titles.tools' | finLocalization }}</div>
      </li>
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.SHARP_OBJECTS"></fcom-icon>
        <div class="ps-small-l">
          <div>{{ 'MMB.checkIn.steps.rules.titles.sharpObjects' | finLocalization }}</div>
          <div class="font-body-2 regular-type">
            {{ 'MMB.checkIn.steps.rules.descriptions.sharpObjects' | finLocalization }}
          </div>
        </div>
      </li>
    </ul>
  </div>
  <div class="ps-medium-x ps-medium-t">
    <div class="flex flex--middle ps-medium-y">
      <h3 class="flex-1 font-heading-5 error-900-text">
        {{ 'MMB.checkIn.steps.rules.titles.notPermittedOnBoard' | finLocalization }}
      </h3>
      <div class="ps-medium-l flex--nogrow">
        <fcom-icon class="icon-large nordic-blue-300-text" [name]="SvgLibraryIcon.CARRY_ON_PROHIBITED"></fcom-icon>
      </div>
      <div class="ps-medium-l flex--nogrow">
        <fcom-icon class="icon-large nordic-blue-300-text" [name]="SvgLibraryIcon.CHECKED_BAG_PROHIBITED"></fcom-icon>
      </div>
    </div>
    <ul class="no-list-style">
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.POWER_BANK_PROHIBITED"></fcom-icon>
        <div class="ps-small-l">
          <div>{{ 'MMB.checkIn.steps.rules.titles.lithiumBatteriesHigh' | finLocalization }}</div>
          <div class="font-body-2 regular-type">
            {{ 'MMB.checkIn.steps.rules.descriptions.lithiumBatteriesHigh' | finLocalization }}
          </div>
        </div>
      </li>
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.SCOOTER_PROHIBITED"></fcom-icon>
        <div class="ps-small-l">
          <div>{{ 'MMB.checkIn.steps.rules.titles.batteryTransportation' | finLocalization }}</div>
          <div class="font-body-2 regular-type">
            {{ 'MMB.checkIn.steps.rules.descriptions.batteryTransportation' | finLocalization }}
          </div>
        </div>
      </li>
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.EXPLOSIVES_PROHIBITED"></fcom-icon>
        <div class="ps-small-l">
          <div>{{ 'MMB.checkIn.steps.rules.titles.explosives' | finLocalization }}</div>
          <div class="font-body-2 regular-type">
            {{ 'MMB.checkIn.steps.rules.descriptions.explosives' | finLocalization }}
          </div>
        </div>
      </li>
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.FLAMMABLE_GASES_PROHIBITED"></fcom-icon>
        <div class="ps-small-l">
          <div>{{ 'MMB.checkIn.steps.rules.titles.flammableGas' | finLocalization }}</div>
          <div class="font-body-2 regular-type">
            {{ 'MMB.checkIn.steps.rules.descriptions.flammableGas' | finLocalization }}
          </div>
        </div>
      </li>
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.RADIOACTIVE_PROHIBITED"></fcom-icon>
        <div class="ps-small-l">{{ 'MMB.checkIn.steps.rules.titles.toxic' | finLocalization }}</div>
      </li>
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.POISON_PROHIBITED"></fcom-icon>
        <div class="ps-small-l">{{ 'MMB.checkIn.steps.rules.titles.biohazard' | finLocalization }}</div>
      </li>
      <li class="flex flex--middle ps-medium-y">
        <fcom-icon class="icon-large" [name]="SvgLibraryIcon.CORROSIVES_PROHIBITED"></fcom-icon>
        <div class="ps-small-l">
          <div>{{ 'MMB.checkIn.steps.rules.titles.corrosive' | finLocalization }}</div>
        </div>
      </li>
    </ul>
  </div>
  <div
    class="ps-medium-x ps-medium-t font-body-1 regular-type"
    *ngIf="'MMB.checkIn.steps.rules.links.restrictedItems.url' | finHasLocalizationKey"
  >
    <cms-unstyled-fragment
      [contentUrl$]="'MMB.checkIn.steps.rules.links.restrictedItems.url' | finLocalization | finToObservable"
    ></cms-unstyled-fragment>
  </div>
</div>

<fcom-cta-button
  [loading]="buttonLoading$ | async"
  [title]="'MMB.checkIn.funnel.steps.restrictedItems.button.title' | finLocalization"
  [position]="ButtonPosition.GRID_FULL"
  [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
  (buttonClicked)="confirmStep.emit()"
>
  <span class="gray-50-text"
    >{{ 'MMB.checkIn.funnel.steps.restrictedItems.button.description' | finLocalization }}
  </span>
</fcom-cta-button>
